var mode = "production";

var search = window.location.search;
var localStorageValidPeriod = 7; //days

if(document.referrer){
    //only stash referrers if they are external
    if(document.referrer.indexOf(location.hostname) === -1){
        stashToLocalStorage("Middleware_Source", document.referrer);
    }
}

if(isQueryStringPresent(search)){
    //save the query string to local storage
    _console(search,"Middleware_Landing");
    stashToLocalStorage("Middleware_Landing", location.pathname + search);
}

if(validateLocateStorageTimestamp()){
    setHiddenFieldValues();
}

function setHiddenFieldValues(){
    let forms = document.querySelectorAll("form");
    forms.forEach(function(form){

        //find hidden fields that match the pattern
        let fields = form.querySelectorAll('.gfield.d-none');
        fields.forEach(function(field){

           // console.log(field,"field");
            let label = field.querySelector('.gfield_label').innerHTML;
           // console.log(label,"label");
            if(label){
                let value = getLocalStorageValue(label);
               // console.log(value,"value");
                if(value){
                    // console.log(field.querySelector('[type="text"]'),"input field");
                    field.querySelector('[type="text"]').setAttribute("value", value);
                }
            }

        });
       
    });
}

function getLocalStorageValue(key){
    let value = localStorage.getItem(key);
    if(value){
        return value;
    }

    return "";
}

function stashToLocalStorage(key, value){
    updateLocalStorageTimestamp();
    localStorage.setItem(key, value);
}

function validateLocateStorageTimestamp(){
    let now = Date.now();
    let then = localStorage.getItem("rebel-utm-timestamp");

    if(now && then){
        let diff = now - then;
        diff = diff / (1000 * 60 * 60 * 24);
        if(diff >= localStorageValidPeriod){
            return false;
        }
    }

    return true;
}

function updateLocalStorageTimestamp(){
    localStorage.setItem('rebel-utm-timestamp', Date.now());
}

function isQueryStringPresent(){ 
    return (search && search.indexOf("utm_source") > -1) ? true : false;
}

function _console(value, text){
    if(mode === 'dev'){
        console.log(value,text);
    }
}